import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import MyButton from '../utils/MyButton';

//redux
import { useDispatch, useSelector } from 'react-redux';
import MyInfo from '../utils/MyInfo';
import { Divider, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
    },

    // dialogContent: {
    //     display: 'flex',
    //     background: "#eeeeee",
    //     alignItems: 'center',
    //     flexDirection: 'column',
    // },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    spaceRight2: {
        marginRight: theme.spacing(1),
    },
    formControl: {
        //margin: theme.spacing(1), 
        width: '100%',
        textAlign: 'left'
    },
    dialogTitleApr: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between'
        }

    },
    noMarginTop: {
        marginTop: "0px",
    }

}));

export default function ConfirmClientInfosAprModal(props) {

    const { open, infos: { preponentName,
        preponentCpf,
        responsableOperationName,
        responsableOperationCpf,
        managerName,
        managerCpf,
    }, handleCancel, handleConfirm } = props;

    const classes = useStyles();

    const dispatch = useDispatch();

    useEffect(() => {


    }, [])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={open}>
            <DialogTitle>
                Confirmar informações de Gestão do RPPS
            </DialogTitle>
            <DialogContent
                className={classes.dialogContent}>

                <Typography>
                    Verifique se as informações de gestão do RPPS estão corretas antes de salvar ou imprimir a APR. Caso haja alguma informação incorreta, cancele a operação e atualize os dados.
                </Typography>

                <br />

                <MyInfo direction={'horizontal'} outerlabel={'Representante Legal:'} label={preponentName} />
                <MyInfo direction={'horizontal'} outerlabel={'CPF Representante Legal:'} label={preponentCpf} />
                <br />
                <Divider />
                <br />
                <MyInfo direction={'horizontal'} outerlabel={'Proponente/Gestor:'} label={managerName} />
                <MyInfo direction={'horizontal'} outerlabel={'CPF Proponente/Gestor:'} label={managerCpf} />
                <br />
                <Divider />
                <br />
                <MyInfo direction={'horizontal'} outerlabel={'Liquidante:'} label={responsableOperationName} />
                <MyInfo direction={'horizontal'} outerlabel={'CPF Liquidante:'} label={responsableOperationCpf} />


            </DialogContent>
            <DialogActions className={classes.actionsFlex}>

                <MyButton onClick={() => handleCancel()} color="secondary">
                    Cancelar
                </MyButton>
                <MyButton
                    className={classes.spaceRight2}
                    onClick={() => handleConfirm()} color="primary">
                    Confirmar
                </MyButton>
            </DialogActions>

        </Dialog >
    );
}